<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Transferred',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'Передано в РЭС'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>

